import React from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import Colors from '@domain/constant/colors';
import { AccaRouteUrl, V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './emptyResult.module.scss';

const cx = classnames.bind(styles);

const EmptyResult = () => {
  return (
    <>
      {/* 결과 도움말 */}
      <div className={cx('emptyResultArea')}>
        <div className={cx('emptyResultWrap')}>
          <em className={cx('title')}>아직 역량검사 응시 전이에요.</em>
          <span className={cx('desc')}>
            역검 응시 한 번으로 입사 제안 받는 방법, 자세히 알아볼까요?
            <Link href={V2Route.getInfo395Page()} legacyBehavior>
              <a className={cx('link')} target={'_blank'}>
                알아보기
                <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_BLUE_100} />
              </a>
            </Link>
          </span>
          <Link href={AccaRouteUrl.ACCA_TEST_GATE} legacyBehavior>
            <a className={cx('btn')}>역검 응시하기</a>
          </Link>
        </div>
      </div>
    </>
  );
};

export default EmptyResult;
